import Config from '@config';
import {
  BiDashboardEmbedTokenArgs,
  BiDashboardEmbedTokenResponse,
  initializeBiDashboardsApi,
} from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

const sharedBiDashboards = initializeBiDashboardsApi({
  baseUrl: `${Config.VITE_API_URL}/bi-dashboards`,
  baseQuery: axiosBaseQuery,
});

// BI in CRM is one dashboard for the whole group (PO, 2026-10-30): the user picks any organization of
// the group, which goes to the backend as the `organizationId` query parameter (GSB-8537). The shared
// endpoint would send it as the `organizationId` header, which on CRM stays the session's organization.
export const biDashboardsApi =
  sharedBiDashboards.biDashboardsApi.injectEndpoints({
    endpoints: builder => ({
      // Tokens are short-lived and per organization: never serve one from the cache.
      getBiDashboardEmbedToken: builder.query<
        BiDashboardEmbedTokenResponse,
        BiDashboardEmbedTokenArgs
      >({
        query: ({ id, organizationId }) => ({
          url: `/${id}/embed-token`,
          method: 'GET',
          params: { organizationId },
        }),
        keepUnusedDataFor: 0,
      }),
    }),
    overrideExisting: true,
  });

export const { useGetBiDashboardsQuery, useLazyGetBiDashboardEmbedTokenQuery } =
  biDashboardsApi;
